import { useI18n } from "@/locales/i18n-provider";
import { EmbeddedNotice } from "../components/embedded-notice";

/**
 * 功能权限或对象范围 403（设计 §13）。
 *
 * 注意与 401 的区别：403 是确定性结果，**绝不能**触发换票循环（AR-16）。
 * 准入类 403（未开通 / 停用 / 无角色）由 `SessionProvider` 直接拦下，不会走到这里。
 */
export default function EmbeddedAccessDeniedPage() {
  const { t } = useI18n();
  return <EmbeddedNotice title={t("embedded.accessDenied.title")} detail={t("embedded.accessDenied.detail")} />;
}
